// extracted by mini-css-extract-plugin
export default {"input_wrapper":"rich-text-editor-v1_input_wrapper__JTLwt","input":"rich-text-editor-v1_input__KK-l3"};